import Vue from 'vue'
import vuex from 'vuex'
import { scrollToBottom } from '@/utils/index'

Vue.use(vuex)

// Create a new store instance.
const store = new vuex.Store({
    state() {
        return {
            user: localStorage.getItem('user'), // 示例
            simuid: localStorage.getItem('simuid'), // 用户simuid
            patientId: localStorage.getItem('patientId'), // 用户患者ID
            token: localStorage.getItem('token'), // token
            registry: localStorage.getItem('registry') == 'true', // 是否注册
            itemId: localStorage.getItem('itemId'), // 是否注册
            refreshNum: localStorage.getItem('refreshNum') ? Number(localStorage.getItem('refreshNum')) : 0, // 页面刷新次数
            pageLoding: true, // 页面加载中
            messageList: [], // 消息列表
            questionList: [], // associateSearch Result
            page: 1, // 历史记录当前所在页码
        }
    },
    mutations: { // 同步
        set_user(state, user) { // 示例
            state.user = user
            localStorage.setItem('user', user)
        },
        clear_all() { // 清除所有
            // console.log('清除所有', this);
            this.commit('set_simuid', '')
            this.commit('set_patientId', '')
            this.commit('set_token', '')
            this.commit('set_registry', '')
            this.commit('set_itemId', '')
        },
        set_simuid(state, param) { // 用户信息
            state.simuid = param
            localStorage.setItem('simuid', state.simuid)
        },
        set_patientId(state, patientId) { // 用户信息
            state.patientId = patientId
            localStorage.setItem('patientId', patientId)
        },
        set_token(state, token) { // 用户信息
            state.token = token
            localStorage.setItem('token', token)
        },
        set_registry(state, param) { // 是否注册
            state.registry = param
            localStorage.setItem('registry', param)
        },
        set_messageList(state, param){ // 添加消息
            if (Object.prototype.toString.call(param) == '[object Object]' && param.item) {
                const { item, unshift } = param
                if (unshift) {
                    state.messageList.unshift(item)
                    return
                } else {
                    param = item
                }
            }
            state.messageList.push(param)
            setTimeout(() => {
                scrollToBottom(document.querySelector('#el-main'))
            }, 100)
        },
        update_messageList(state, param){ // 更新消息
            state.messageList = param
        },
        set_questionList(state,param){
            state.questionList = param
        },
        set_itemId(state, param){
            state.itemId = param
        },
        set_pageLoding(state, param) { // 设置页面加载状态
            state.pageLoding = param
        },
        set_page(state, param) { // 历史记录当前所在页码
            state.page = param
        },
        set_refreshNum(state, param) { // 页面刷新次数
            state.refreshNum = param
        }
    },
    getters:{
        get_messageList(state){
            return state.messageList
        },
        get_questionList(state){
            return state.questionList
        },
        get_itemId(state){
            return state.itemId
        },
    },
    actions: { // 异步
        set_user(context, user) { // 示例
            context.commit('set_user', user)
        }
    }
})

export default store